import http from "./httpservices";

export async function FetchAllPaymentsStatus(params) {
  return http.get("status/payment", { params: params });
}

export default { FetchAllPaymentsStatus };
